module.exports = __webpack_public_path__ + "img/NCB.c013166c.png";